import { db } from "../../../service/API";

export class ProfileLogConnector {
  constructor(userData) {
    this.userId = userData.userId;
    this.socId = userData.socId;
  }

  getConnectionLogs() {
    return new Promise((resolve, reject) => {
      db.get("/ProfileLogConnector/getConnectionLogs/" + this.socId)
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("getConnectionLogs failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("getConnectionLogs failed with error : " + err.message);
        });
    });
  }

  insertConnectionLog() {
    return new Promise((resolve, reject) => {
      db.post("/ProfileLogConnector/insertConnectionLog/", { uid: this.userId })
        .then((response) => {
          if (response.status == 201) {
            return resolve();
          } else {
            return reject("insertConnectionLog failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("insertConnectionLog failed with error : " + err.message);
        });
    });
  }
}
